import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
} from '@mui/material';
import {
  Psychology as PsychologyIcon,
  Description as DescriptionIcon,
  LibraryBooks as LibraryBooksIcon,
} from '@mui/icons-material';
import PromptManagement from '../components/Admin/PromptManagement';
import HtmlTemplateManagement from '../components/DocumentManagement/HtmlTemplateManagement';
import IPCatalog from '../components/DocumentManagement/IPCatalog';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faana-agents-tabpanel-${index}`}
      aria-labelledby={`faana-agents-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function FaanaAgents() {
  const [tabValue, setTabValue] = useState(0);

  // Load persisted tab selection on mount
  useEffect(() => {
    const savedTab = localStorage.getItem('faanaAgentsSelectedTab');
    if (savedTab !== null) {
      setTabValue(parseInt(savedTab, 10));
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem('faanaAgentsSelectedTab', newValue.toString());
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Faana Agents
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Manage AI agent personas, document templates, and intellectual property
      </Typography>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab
          icon={<PsychologyIcon />}
          label="Agent Personas"
          iconPosition="start"
          id="faana-agents-tab-0"
          aria-controls="faana-agents-tabpanel-0"
        />
        <Tab
          icon={<DescriptionIcon />}
          label="Smart Templates"
          iconPosition="start"
          id="faana-agents-tab-1"
          aria-controls="faana-agents-tabpanel-1"
        />
        <Tab
          icon={<LibraryBooksIcon />}
          label="IP Catalogue"
          iconPosition="start"
          id="faana-agents-tab-2"
          aria-controls="faana-agents-tabpanel-2"
        />
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <PromptManagement />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <HtmlTemplateManagement />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <IPCatalog />
      </TabPanel>
    </Box>
  );
}

export default FaanaAgents;
